module.exports = __webpack_public_path__ + "static/media/au-wa.34960e07.svg";